'use client'

import { useEffect } from 'react'
import { useCartStore } from '@/store/useCartStore'

export function CartLoader() {
  const loadItems = useCartStore(state => state.loadItems)

    useEffect(() => {
        loadItems()
    }, [loadItems])

    return null
}
